import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useChat } from '~/hooks/Chat/IntercomChat';
import { useAnalytics } from '~/hooks/useAnalytics';
import HelpIcon from '~/icons/icon-help.svg?react';
import { AnalyticsEvents } from '~/services/analytics';
import { useIsSubmenuOpen, useSetSubmenu } from '~/state/navigationSidebar';
import { SubmenuItem, SubmenuSection } from '~/types/sidebar';
import NavigationSidebarItem from '../NavigationSidebarItem';

const SupportItem: React.FC = () => {
  const { t } = useTranslation('sidebar');
  const { track } = useAnalytics();
  const isSubmenuOpen = useIsSubmenuOpen('support');
  const openSubmenu = useSetSubmenu('support');
  const { show, isStarted, open } = useChat();

  const sections: SubmenuSection[] = useMemo(() => {
    const intercomSubmenu: SubmenuItem = {
      label: t('support.submenu.chat'),
      action: () => {
        show();
        open();
      },
    };
    const faqSubmenu: SubmenuItem = {
      label: t('support.submenu.faq'),
      action: () => {
        window.open('https://intercom-help.eu/sibill-eu-workspace/it', '_blank')?.focus();
        track(AnalyticsEvents.FAQ_PAGE_VISITED);
      },
    };
    const contactSubmenu: SubmenuItem = {
      label: t('support.submenu.contact_us'),
      action: () => {
        window.open('https://share-eu1.hsforms.com/17KblJNbeSfesHhV9_J9SVgev8u2', '_blank')?.focus();
        track(AnalyticsEvents.CONTACT_FORM_VISITED);
      },
    };

    return [{ items: isStarted ? [intercomSubmenu, faqSubmenu] : [contactSubmenu, faqSubmenu] }];
  }, [t, isStarted, show, open, track]);

  return (
    <>
      <NavigationSidebarItem
        iconComponent={HelpIcon}
        title={t('support.label')}
        isSubmenuOpen={isSubmenuOpen}
        onOpenSubmenu={openSubmenu}
        submenuSections={sections}
        isActive={false}
      />
    </>
  );
};

export default memo(SupportItem);
